<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props:{
            title: {
                default(){
                    return 'Select Side Panel Composite Style';
                }
            },
            doorRange: {
                required: true,
            },
            slab: {
              required: false,
              default: 0,
            }
        },
        computed: {
            valid_selection(){
                if (!this.options_loaded) {
                    return false;
                }

                return this.filtered_option_list.find(y => {
                            return y.value == this.localTarget;
                        }) !== undefined;
            },
            thumbURL(){
                return '/thumb/compside/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/comp-panel?door_range=' + this.doorRange + '&slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.doorRange + '_' + this.slab;
            },
        },
        methods: {
            select_first(){
                if ((this.filtered_option_list.length === 0)) {
                    this.localTarget = undefined;
                    return;
                }

                var new_value = this.filtered_option_list[0];

                this.localTarget = new_value.value;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            }
        },
    }
</script>
